// App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Curriculum from "./pages/Curriculum";
import Test from "./pages/Test";
import Diagnosis from "./pages/Diagnosis";
import Support from "./pages/Support";
import Manual from "./pages/Manual";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import AutoLogin from "./pages/AutoLogin";
import { isLoggedIn } from "./components/Auth";
import { LoadingProvider, useLoading } from "./components/LoadingContext";
import { setLoadingSetter } from "./components/LoadingControl";
import { ErrorProvider } from "./components/ErrorContext";
import DailyRecord from './pages/DailyRecord'; // ページを読み込み
import "./styles/common.css"

function RequireAuth({ children }) {
  return isLoggedIn() ? children : <Navigate to="/login" replace />;
}

const LoadingIndicator = () => {
  const { loading, setLoading } = useLoading();
  setLoadingSetter(setLoading);
  return loading ? (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  ) : null;
};

function App() {
  return (
    <ErrorProvider>
      <LoadingProvider>
        <LoadingIndicator />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              
              {/* ログイン（Layoutあり） */}
              <Route path="login" element={<Login />} />
              <Route path="auto-login" element={<AutoLogin />} />

              {/* 認証必須ルート */}
              <Route index element={<RequireAuth><Home /></RequireAuth>} />
              <Route path="curriculum" element={<RequireAuth><Curriculum /></RequireAuth>} />
              <Route path="test"       element={<RequireAuth><Test       /></RequireAuth>} />
              <Route path="support"    element={<RequireAuth><Support    /></RequireAuth>} />
              <Route path="manual"     element={<RequireAuth><Manual     /></RequireAuth>} />
              <Route path="admin"      element={<RequireAuth><Admin      /></RequireAuth>} />
              <Route path="diagnosis"  element={<RequireAuth><Diagnosis  /></RequireAuth>} />
              <Route path="/daily-record/:loginCode" element={<RequireAuth><DailyRecord  /></RequireAuth>} />
              {/* 存在しないパスはホームへリダイレクト */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LoadingProvider>
    </ErrorProvider>
  );
}

export default App;
